.shell {
  display: grid;
  grid-template-columns: var(--sidebar-width) minmax(0, 1fr);
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--bg-canvas);
}

.main {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.content {
  flex: 1;
  width: 100%;
  max-width: var(--content-max);
  margin: 0 auto;
  padding: var(--space-8) var(--space-8) var(--space-16);
  animation: ela-fade-in var(--duration-normal) var(--ease-out);
}

.scrim {
  position: fixed;
  inset: 0;
  z-index: calc(var(--z-sidebar) - 1);
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(2px);
  border: none;
  cursor: default;
}

/* ---- Tablet: sidebar becomes an overlay drawer ---- */
@media (max-width: 1024px) {
  .shell {
    grid-template-columns: minmax(0, 1fr);
  }

  .content {
    padding: var(--space-6) var(--space-5) var(--space-12);
  }
}

@media (max-width: 640px) {
  .content {
    padding: var(--space-5) var(--space-4) var(--space-12);
  }
}
